import React, { useState } from 'react';
import {
  Typography,
  Button,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Link,
  Radio,
  RadioGroup
} from '@mui/material';
import { useUser } from '../../../../contexts/UserContext';
import { useNetwork } from '../../../../utils/network';
import { useShowSnackbar } from '../../../../utils/snackbar';

type Props = {};

export const SettingsTAndC = (props: Props) => {
  const { user, setUser } = useUser();
  const { post } = useNetwork();
  const { showSnackbar } = useShowSnackbar();

  const [readDocs, setReadDocs] = useState<boolean>(false);
  const [isGiveawayEligible, setIsGiveawayEligible] = useState<boolean | null>(
    null
  );

  const giveawayEligibilityUpdatedSubmit = async () => {
    try {
      const result = await post(
        '/user/updateUserGiveawayEligibility',
        { giveawayEligibilityStatus: isGiveawayEligible },
        true
      );
      setUser({
        ...user,
        isGiveawayEligible: isGiveawayEligible
      });
      showSnackbar(result.message, 'success');
    } catch (error: any) {
      showSnackbar(error.response.data.message, 'error');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Typography variant="h2" textAlign="center" fontWeight={800}>
          T&Cs
        </Typography>
      </Box>
      <Box sx={{ px: 2, paddingBottom: '3rem' }}>
        <Typography
          variant="h5"
          fontWeight="bold"
          textAlign="center"
          sx={{ pb: '2rem' }}
        >
          Please Read the T&Cs
        </Typography>
        <Typography sx={{ pb: '1rem' }}>
          T&Cs are found here:{' '}
          <Link
            href="https://incrypt-public-assets-global.s3.ap-southeast-2.amazonaws.com/documents/terms_and_conditions_05_08_2026.docx"
            rel="noopener noreferrer"
            variant="body2"
            target="_blank"
            style={{ fontSize: '16px' }}
          >
            INCRYPT Terms & Conditions
          </Link>
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              onChange={() => {
                setReadDocs(!readDocs);
              }}
            />
          }
          label={
            <Typography>
              I have read and agree to the{' '}
              <Link
                href="https://incrypt-public-assets-global.s3.ap-southeast-2.amazonaws.com/documents/terms_and_conditions_05_08_2026.docx"
                rel="noopener noreferrer"
                variant="body2"
                target="_blank"
                style={{ fontSize: '16px' }}
              >
                terms and conditions
              </Link>
            </Typography>
          }
          labelPlacement="end"
          sx={{ my: '1rem' }}
        />

        <FormControl>
          <FormLabel id="giveaway-Eligibility">
            You have read the T&Cs and are eligible for giveaways
          </FormLabel>
          <RadioGroup
            onChange={(e) => setIsGiveawayEligible(e.target.value === 'yes')}
          >
            <FormControlLabel
              value="yes"
              control={<Radio required={true} />}
              label="Yes I am eligible for giveaways"
            />
            <FormControlLabel
              value="no"
              control={<Radio required={true} />}
              label="No I am not eligible for giveaways"
            />
          </RadioGroup>
        </FormControl>
      </Box>

      <Box sx={{ px: 2, paddingBottom: '3rem' }}>
        <Typography variant="h6">
          Your eligibility status determines whether you receive giveaway
          entries with future purchases. If you are eligible, you’ll earn
          entries. If not, you won’t.
        </Typography>
        <Typography variant="h6" sx={{ mt: 1 }}>
          <strong>Note:</strong> Changing your eligibility status will not apply
          retroactively. Purchases made while ineligible will not grant entries,
          even if you later become eligible.
        </Typography>
      </Box>

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Button
          variant="contained"
          onClick={giveawayEligibilityUpdatedSubmit}
          disabled={readDocs === false || isGiveawayEligible === null}
        >
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
